// Terms & Conditions modal. Displays the full text with a scrollable list of numbered
// clauses. Optionally shows an "أوافق" primary button (used when opened from the
// Register form via `data-testid="reg-terms-open"`).
import { X, ScrollText, CheckCircle2 } from "lucide-react";
import { TERMS_TITLE, TERMS_INTRO, TERMS } from "@/data/terms";

export default function TermsModal({ onClose, onAccept }) {
  return (
    <div className="fixed inset-0 z-[60] bg-black/60 backdrop-blur-sm flex items-end sm:items-center justify-center p-4"
         onClick={onClose} data-testid="terms-modal">
      <div onClick={(e) => e.stopPropagation()}
           className="bg-white w-full sm:max-w-2xl rounded-3xl shadow-2xl max-h-[92vh] overflow-hidden flex flex-col">
        {/* Header */}
        <div className="p-5 flex items-center justify-between text-white"
             style={{background: "linear-gradient(135deg, #1E3A8A 0%, #2547D0 100%)"}}>
          <div className="flex items-center gap-3">
            <div className="w-11 h-11 rounded-2xl bg-white/20 flex items-center justify-center">
              <ScrollText size={22}/>
            </div>
            <div>
              <div className="font-black text-lg" style={{fontFamily:"Cairo"}}>{TERMS_TITLE}</div>
              <div className="text-xs opacity-90">اقرأها بعناية قبل إنشاء حسابك</div>
            </div>
          </div>
          <button onClick={onClose} className="w-9 h-9 rounded-lg bg-white/15 hover:bg-white/25 flex items-center justify-center"
                  data-testid="terms-close">
            <X size={16}/>
          </button>
        </div>

        {/* Body */}
        <div className="flex-1 overflow-y-auto p-5 space-y-3">
          <p className="text-sm leading-relaxed text-[var(--text-secondary)]">{TERMS_INTRO}</p>
          <ol className="space-y-3">
            {TERMS.map((c, i) => (
              <li key={c.title} className="bg-[var(--surface-alt)] rounded-2xl p-4 border border-[var(--border)]" data-testid={`terms-item-${i + 1}`}>
                <div className="flex items-start gap-2">
                  <span className="w-7 h-7 shrink-0 rounded-full bg-primary-brand text-white flex items-center justify-center text-xs font-black">
                    {i + 1}
                  </span>
                  <div className="flex-1 min-w-0">
                    <div className="font-black text-sm" style={{fontFamily:"Cairo"}}>{c.title}</div>
                    <div className="text-sm text-[var(--text-primary)] mt-1 leading-relaxed">{c.body}</div>
                  </div>
                </div>
              </li>
            ))}
          </ol>
        </div>

        {/* Footer */}
        <div className="p-4 border-t border-[var(--border)] flex flex-col-reverse sm:flex-row gap-2">
          <button onClick={onClose}
                  className="flex-1 py-2.5 rounded-xl bg-[var(--surface-alt)] hover:bg-[var(--border)] font-black text-sm"
                  data-testid="terms-close-btn">
            إغلاق
          </button>
          {onAccept && (
            <button onClick={() => { onAccept(); onClose(); }}
                    className="flex-1 py-2.5 rounded-xl bg-primary-brand text-white font-black text-sm flex items-center justify-center gap-1.5 hover:opacity-90 talabya-shadow-float"
                    data-testid="terms-accept">
              <CheckCircle2 size={14}/> أوافق على الشروط والأحكام
            </button>
          )}
        </div>
      </div>
    </div>
  );
}
